import AddIcon from '@mui/icons-material/Add';
import { IconButton } from '@mui/material';
import { useMemo } from 'react';
import { Tooltip } from 'src/components';
import { SearchDialog, SearchDialogItem } from 'src/components/SearchDialog/search-dialog';
import { Address } from 'src/graphql/entities/address/address';
import { DEFAULT_PAGINATION_LIMIT } from 'src/graphql/entities/search/use-search';
import { ConditionInput } from 'src/graphql/types';
import { Modals, useModalMethods } from 'src/store/modals';
import { useScreenDimensions } from 'src/utils/system';

type SelectSiteDialogProps = {
  loading?: boolean;
  filters: ConditionInput[];
  options: SearchDialogItem[];
  onNewSiteAdded?: (newValue: Address) => void;
  onSearchChange: (value: string) => void;
  onNewSiteCreationCanceled?: () => void;
  onClose?: () => void;
  onSelect?: (item: SearchDialogItem) => void;
};

export const SelectSiteDialog = ({
  loading,
  filters,
  onNewSiteAdded,
  onNewSiteCreationCanceled: onNewSiteClosed,
  ...props
}: SelectSiteDialogProps) => {
  const { isMobile } = useScreenDimensions();
  const { showModal: showSiteModal } = useModalMethods(Modals.AddSiteModal);

  const renderSearchDialogFooter = useMemo(() => {
    return (
      <Tooltip title="Create Site">
        <IconButton
          onClick={() => {
            showSiteModal({
              ...(onNewSiteClosed ? { onCloseModal: onNewSiteClosed } : {}),
              ...(onNewSiteAdded ? { onSuccessSubmit: onNewSiteAdded } : {}),
              filters,
              limit: DEFAULT_PAGINATION_LIMIT * 10,
            });
          }}
          color="primary"
          sx={{
            width: '100%',
            justifyContent: 'flex-start',
            borderTop: '1px solid',
            borderRadius: 0,
            borderColor: (theme) => theme.palette.custom.OV.sys.outlineVariant,
            padding: 2,
            textAlign: 'left',
          }}
        >
          <AddIcon />
          <span style={{ fontSize: '0.9rem', marginLeft: '5px', textTransform: 'uppercase' }}>
            Create site
          </span>
        </IconButton>
      </Tooltip>
    );
  }, [showSiteModal, onNewSiteClosed, onNewSiteAdded, filters]);

  return (
    <SearchDialog
      loading={props.options.length === 0 && loading}
      showProgress={loading}
      placeholder="Type to find and associate site..."
      onSearchChangeDebounce={500}
      footer={renderSearchDialogFooter}
      {...(!isMobile && { endAdornment: false })}
      {...props}
    />
  );
};
